import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Flex } from 'foundations-components/components/Flex';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped dep
import IFrame from 'ui-addon-iframeable/host/IFrame';
import { trackPageView, trackInteraction } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EmbeddedContentPage({
  src,
  title,
  breadcrumbs,
  subscreen,
  footer,
  onMessage
}) {
  const history = useHistory();
  useEffect(() => {
    trackPageView(subscreen);
  }, [subscreen]);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    flexGrow: 1,
    backgroundColor: "fill-surface-default",
    children: [/*#__PURE__*/_jsx(Flex, {
      paddingInline: "600",
      paddingBlock: "400",
      backgroundColor: "fill-surface-default",
      children: /*#__PURE__*/_jsx(Breadcrumbs, {
        flush: false,
        "data-test-id": "embedded-content-breadcrumbs",
        children: breadcrumbs.map((breadcrumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          return isLast ? /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: breadcrumb.label,
              options: breadcrumb.options
            })
          }, index) : /*#__PURE__*/_jsx(Link, {
            onClick: () => {
              trackInteraction('breadcrumb-clicked', {
                destination: breadcrumb.href || '/'
              });
              history.push(breadcrumb.href || '/');
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: breadcrumb.label,
              options: breadcrumb.options
            })
          }, index);
        })
      })
    }), /*#__PURE__*/_jsx(IFrame, {
      src: src,
      onReady: () => {},
      onMessage: onMessage,
      iframePassthruProps: {
        'data-test-id': 'embedded-content-iframe',
        style: {
          border: 'none',
          width: '100%',
          flexGrow: 1,
          height: 'calc(100vh - 120px)'
        },
        title
      }
    }), footer]
  });
}